module.exports = __webpack_public_path__ + "img/coo_session.22805c06.png";